import { accountIdFormat } from "@redotech/redo-account-id";
import {
  MongoFaqArticleId,
  MongoFaqCollectionId,
  MongoFaqPageId,
} from "@redotech/redo-ids-mongo";
import {
  agentKnowledgeIdFormat,
  faqKnowledgeIdFormat,
} from "@redotech/shopper-agent-knowledge-id";
import * as z from "zod";
import {
  merchantKnowledgeAvailabilitySchema,
  retrievalKeySchema,
} from "./merchant-knowledge-view";

// Merchant-surface shapes for FAQ knowledge. Title/content hydrate at read
// time — read-only by construction; the editable source is the FAQ editor.

export const faqKnowledgeEntrySchema = z.object({
  id: faqKnowledgeIdFormat.schema,
  /** Registry id. Retrieval hits carry this, not `id`. */
  agentKnowledgeId: agentKnowledgeIdFormat.schema,
  accountId: accountIdFormat.schema,
  /** Mongo ObjectIds of the FAQ entities, as 24-char hex strings. */
  faqPageId: MongoFaqPageId,
  faqCollectionId: MongoFaqCollectionId,
  faqArticleId: MongoFaqArticleId,
  /** Hydrated `[page] > [collection] > [article]`. */
  title: z.string(),
  /** Hydrated article body as text. */
  content: z.string(),
  retrievalKey: retrievalKeySchema,
  availability: merchantKnowledgeAvailabilitySchema,
  /** Messages this entry was used for, from `ai_knowledge_use`. */
  useCount: z.number(),
  createdAt: z.date(),
  updatedAt: z.date(),
});
export type FaqKnowledgeEntry = z.infer<typeof faqKnowledgeEntrySchema>;

/** A row in a management list: the above minus its body. */
export const faqKnowledgeListItemSchema = faqKnowledgeEntrySchema.omit({
  content: true,
});
export type FaqKnowledgeListItem = z.infer<typeof faqKnowledgeListItemSchema>;
